<template>
  <div tabindex="0" @blur="dropdownActive = false" class="navbar-item has-dropdown is-fullheight"
    :class="{ 'is-active': dropdownActive }">
    <a class="is-fullheight" @click="isSubscribed ? toggleDropdown() : notificationRequest()">
      <span class="icon" style="position: relative;">
        <i class="fas fa-bell"></i>
        <span v-if="notifications.length > 0" class="notification-badge-dot"></span>
      </span>
    </a>

    <div class="navbar-dropdown is-narrow dropdown-left">

      <div v-if="notifications.length === 0" class="navbar-item">
        <p class="has-text-grey">No Notifications</p>
      </div>

      <div v-else>
        <a class="navbar-item is-flex is-align-items-center hoverClass notification-item" v-for="item in notifications"
          :key="item.Id">
          <div class="is-flex-grow-1 overflow">
            <a :href="item.url">
              <p v-bind:title="item.title" class="title cleanText is-6 mb-0">{{ item.title }}</p>
              <p v-bind:title="item.body" class="content cleanText">{{ item.body }}</p>
            </a>
          </div>

          <span v-if="item.title != 'notifications have been activated'" class="icon is-pulled-right ml-3 mt-1"
            @click.stop="archiveNotification(item.Id)">
            <i class="fas fa-solid fa-box-archive"></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dropdownActive: false,
      isSubscribed: false,
      showNotificationMenu: false,
      publicKey: "",
    };
  },
  computed: {
    notifications: function () {
      return this.$store.getters.getNotificationHistory;
    },
    isAuthReady() {
      return !!(this.$store.getters.connection_id && this.$store.state.myprofile);
    }
  },
  watch: {
    // Watch this combined computed property
    isAuthReady: {
      immediate: true,
      handler(ready) {
        if (ready) {
          console.log("Auth and Profile are ready, initializing notifications...");
          this.initNotifications();
        } else {
          console.log("Waiting for Auth or Profile to be ready...");
        }
      }
    }
  },
  async mounted() {
    this.checkSubscription();
  },
  methods: {
    async initNotifications() {
      // Now you are guaranteed that myprofile exists here
      console.log("getNotificationFromDB CALLED");
      await this.$store.dispatch('getNotificationFromDB');
    },
    toggleDropdown() {
      this.dropdownActive = !this.dropdownActive;
    },
    async archiveNotification(Id) {
      await this.$store.dispatch('update_record', { object: "Task", recordId: Id, properties: { Type: "NotificationArchived" } });
      this.$store.commit('SET_NOTIFICATIONS', (this.notifications.filter(notification => notification.Id !== Id)));
    },
    async loadPublicKey() {
      try {
        const response = await this.$store.dispatch('getNotificationsPublicKey')
        this.publicKey = response.publicKey;
      } catch (e) {
        console.error("Error loading public key:", e);
      }
    },
    async checkSubscription() {
      // APPLE/Modern Browser check
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        this.isSubscribed = false;
        return;
      }

      try {
        const reg = await navigator.serviceWorker.ready;
        const subscription = await reg.pushManager.getSubscription();
        this.isSubscribed = !!subscription;
      } catch (e) {
        console.error("Error checking subscription status: ", e);
        this.isSubscribed = false;
      }
    },
    async notificationRequest() {
      if (!('Notification' in window)) {
        alert('Per abilitare le notifiche su iPhone/iPad, tocca il pulsante Condividi e seleziona "Aggiungi alla schermata Home".');
        return;
      }

      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        alert('Le notifiche push non sono supportate da questo browser.');
        return;
      }

      if (!window.confirm("do you want to enable notifications for this app?")) return;
      try {
        if (!this.publicKey) await this.loadPublicKey();
        const reg = await navigator.serviceWorker.ready;
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          alert("Permesso negato.");
          return;
        }
        const subscription = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: this.base64ToUint8(this.publicKey)
        });

        const payload = {
          targetId: this.$store.state.myprofile.contactId,
          user: this.$store.state.myprofile.user,
          subscription: JSON.stringify(subscription)
        };
        await this.$store.dispatch("subscribeNotifications", payload)


      } catch (e) {
        console.error("Subscribe error:", e);
      } finally {
        await this.checkSubscription();
      }
    },
    base64ToUint8(base64) {
      const pad = '='.repeat((4 - base64.length % 4) % 4);
      const b64 = (base64 + pad).replace(/-/g, '+').replace(/_/g, '/');
      const raw = atob(b64);
      return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
    }
  },
};
</script>

<style scoped>
/* Colori e tema */
.navbar-dropdown {
  --dropdown-hover: var(--bulma-primary);
  --dropdown-divider: var(black);
  --text-color: var(--bulma-text);
  --text-invert: var(--bulma-primary-invert);
}

/* Struttura base */
.navbar-dropdown {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  width: 300px;
  background-color: var(--dropdown-bg);
  border-radius: var(--bulma-radius-large);
  border: solid 1px #9c9c9c39;
  box-shadow: 0 .5em .5em rgba(255, 255, 255, 0.155);
  z-index: 20;
}

.navbar-dropdown .navbar-item {
  padding: 0.5rem 1rem;
  background-color: var(--dropdown-bg);
  color: var(--text-color);
  text-decoration: none !important;
}

.navbar-dropdown .navbar-item .title,
.navbar-dropdown .navbar-item .content {
  color: inherit;
}

/* Interazioni hover */
.navbar-dropdown .navbar-item:hover {
  background-color: var(purple);
}

/* Elementi specifici */
.navbar-dropdown .has-text-grey {
  color: var(--bulma-grey) !important;
}

.navbar-item.has-dropdown.is-active .navbar-dropdown {
  display: block;
}

.overflow {
  width: 93%;
  overflow: hidden;
}

.notification-item:not(:last-child) {
  border-bottom: 1px solid #9c9c9c39;
}

.notification-badge-dot {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 8px;
  height: 8px;
  background-color: #f14668;
  border-radius: 50%; 
  border: 1.5px solid var(--bulma-scheme-main, #1a1a1a); 
  pointer-events: none; 
}

/* Responsive */
@media screen and (min-width: 1024px) {
  .navbar-dropdown {
    min-width: 35vw;
    inset-inline-start: auto;
    background-color: var(--bulma-scheme-main);
  }

  .navbar-dropdown .navbar-item {
    transition: all 0.2s ease-in-out;
  }

  .hoverClass:hover {
    background-color: var(--bulma-link) !important;
    color: white !important;
  }
}

@media screen and (max-width: 1024px) {
  .navbar-dropdown {
    min-width: 15vw;
    inset-inline-start: auto;
    border-bottom: 1px solid var(--dropdown-divider);
    background-color: var(--bulma-scheme-main);
  }

  .navbar-dropdown .navbar-item {
    padding: 0.3rem 0.5rem;
  }

  .navbar-dropdown .navbar-item:hover {
    background-color: var(--dropdown-bg);
    color: var(--text-color);
  }
}
</style>